export default {
  fields: {
    subdomain: {
      placeholder: 'Ex.: meunegocio'
    }
  },
  submitButton: {
    label: 'Adicionar domínio'
  }
}
